import React from 'react';

/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
export const dealDataHeight = (data: any[], num: number = 3) => {
  data.map((item, index) => {
    const { rowSpan } = item;
    for (const key in rowSpan) {
      const cha = num - index;
      if (rowSpan[key] > cha) {
        rowSpan[key] = cha;
      }
    }

    return item;
  });

  return data;
};

export const dealColumns = (columns: any[] = [], data: any[] = []) => {
  if (!data || !Array.isArray(data) || data.length <= 0) {
    return columns;
  }

  columns.map((item) => {
    // 如果存在 则执行用户自定义的函数
    if (item.render) {
      return item;
    }
    // 处理数据
    item.render = (text: string, record: any) => {
      const value = {
        children: (<span style={record.style}>{text}</span>),
        props: {
          rowSpan: 0,
        },
      };

      if (record.rowSpan && Object.keys(record.rowSpan).length) {
        Object.keys(record.rowSpan)
          .map((key) => {
            if (record[key] === text) {
              value.props.rowSpan = record.rowSpan[key] || 0;
            }
            return key;
          });
      } else {
        return <span style={record.style}>{text}</span>;
      }

      if (typeof text === 'undefined') {
        value.props.rowSpan = 0;
      }

      return value;
      // 处理合并的需求
    };
    return item;
  });
  return columns;
};

/**
 * 通过路径
 * @param entity
 * @param path
 *  获取对应的值 eg entity: { name: { firstName: 'Jerome' } }
 *                path:   name.firstName
 *                result: Jerome
 */
export function getValueFromPath(entity, path = '') {
  if (!entity) return undefined;

  if (Object.prototype.toString.call(entity) !== '[object Object]') {
    return entity;
  }

  const tempPath: string[] = [];

  let current = entity;

  path.replace(/([a-zA-Z0-9]+)/g, (text: string) => {
    tempPath.push(text);
    return text;
  });

  for (let i = 0; i < tempPath.length; i += 1) {
    current = current[tempPath[i]];

    if (!current) {
      return current;
    }
  }

  return current;
}

export default {
  dealDataHeight,
  dealColumns,
  getValueFromPath,
};
